import { unitMapping } from '#src/lib/style.ts';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const BaseballMiddleInfielder = ({ size = 2, className }: Props) => (
  <svg
    className={className}
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.27442 5.37988L8.3471 10.6347H6.95612L7.4816 7.65954L5.92834 9.89283H5.37968L4.61464 7.65954L4.08917 10.6347H2.76001L3.68733 5.37988H5.00875L5.92062 8.03819L7.76753 5.37988H9.27442ZM13.022 6.61631H12.0946L11.6001 9.39826H12.5274L12.311 10.6347H9.06541L9.28178 9.39826H10.2091L10.7037 6.61631H9.77635L9.99272 5.37988H13.2383L13.022 6.61631Z"
      fill="white"
    />
  </svg>
);
